const capitalizeFirstLetter = (word: string) => {
  let capitalized = word;
  if (capitalized != null) {
    capitalized = word[0].toUpperCase() + word.slice(1);
  }
  return capitalized;
};

export default capitalizeFirstLetter;
